import { render, staticRenderFns } from "./SellingPoint.vue?vue&type=template&id=4ec8cc94&scoped=true&"
import script from "./SellingPoint.vue?vue&type=script&lang=js&"
export * from "./SellingPoint.vue?vue&type=script&lang=js&"
import style0 from "./SellingPoint.vue?vue&type=style&index=0&id=4ec8cc94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8cc94",
  null
  
)

export default component.exports